/**
 * Device detection utilities for determining platform-specific behaviors
 */

/**
 * Detects if the current device is running iOS
 * Checks for iPhone, iPad, iPod, and newer iPads masquerading as MacBooks
 */
export const isIOS = (): boolean => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

/**
 * Detects if the current device is running Android
 * Uses case-insensitive regex to match Android in user agent
 */
export const isAndroid = (): boolean => {
  return /Android/i.test(navigator.userAgent);
};

/**
 * Detects if running in iOS standalone mode (PWA installed)
 */
export const isIOSStandalone = (): boolean => {
  return (window.navigator as any).standalone === true;
};

/**
 * Detects if the device is likely an Android tablet
 * Uses heuristics: Android in UA + NOT "Mobile" keyword
 */
export const isAndroidTablet = (): boolean => {
  return isAndroid() && !/Mobile/i.test(navigator.userAgent);
};

/**
 * Detects if the device is likely an Android phone
 */
export const isAndroidPhone = (): boolean => {
  return isAndroid() && /Mobile/i.test(navigator.userAgent);
};
